import { render } from "./J.vue?vue&type=template&id=a36d0f66"
import script from "./J.vue?vue&type=script&lang=js"
export * from "./J.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__